import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchProgram, fetchPlaceCategories, addProgramPlaceCategory } from "../../api/companyApi";
import { COMPANY_ID } from "../../config/appConfig";
import { useNotification } from "../../providers/NotificationProvider";

export default function ProgramPlaceCategoryAddPage() {
  const { businessDomainId, businessUnitId, programId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });
  const basePath = `/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`;

  const [available, setAvailable] = useState([]);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [program, all] = await Promise.all([
          fetchProgram(programId),
          fetchPlaceCategories(COMPANY_ID),
        ]);
        const assigned = new Set((program.associatedPlaceCategories || []).map((c) => c.placeCategoryId));
        setAvailable((Array.isArray(all) ? all : []).filter((c) => !assigned.has(c.placeCategoryId)));
      } catch (e) { notify.apiError(e); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId, businessUnitId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedId) { notify.error(t("common.selectRequired")); return; }
    try {
      await addProgramPlaceCategory(programId, selectedId);
      notify.success(t("message.create.success"));
      navigate(`${basePath}/place-categories`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("program.placeCategory.add.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <FormControl fullWidth required>
              <InputLabel>{t("placeCategory.name")}</InputLabel>
              <Select value={selectedId} onChange={(e) => setSelectedId(e.target.value)}
                label={t("placeCategory.name")}>
                {available.map((c) => (
                  <MenuItem key={c.placeCategoryId} value={c.placeCategoryId}>
                    {c.placeCategoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.add")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/strategy/${businessDomainId}/business-units/${businessUnitId}/programs/${programId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
